module.exports = __webpack_public_path__ + "28b67065/img/boston-lights.a623432f.png";